import { t } from '@lingui/core/macro';
import { Alert } from '@pocketlaw/tetris';
import { useFormikContext } from 'formik';
export function MutationError() {
    const { status } = useFormikContext();
    const { mutationError } = status || {};
    if (!mutationError) {
        return null;
    }
    return (<Alert appearance="danger" message={t({
            message: 'An error occurred. Please try again later.',
            comment: 'error alert when failing to add company',
        })}/>);
}
